import React, { useEffect, useRef, useState } from "react";
import * as Yup from "yup";
import {
  FacilityInformation,
  FacilityProcessDetails,
  FacilityState,
} from "../../../sc-models/facility-product-dto";
import FormBuilder from "../../../../../../shared/components/form-builder/form-builder";
import { FormConfigProps } from "../../../../../../shared/components/form-builder/form-builder.model";
import { dtrackItServiceV4 } from "../../../sc-service/dtrackit.service";
import { buyerSellerDetailsService } from "../../../../transaction-certificates/tc-service/buyer-seller-details.service";
import { OptionType } from "../../../../../../shared/components/form-builder/form-config.model";
import { Utills } from "../../../../../../shared/app-configs/utilit";
import { API_ROUTES } from "../../../../../../shared/app-configs/sc-app-config";
import { useApi } from "../../../../../../shared/hooks/useApi";
import { useParams } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import useNotification from "../../../../../../shared/hooks/useNotification";
import { useTransactionCertificateStore } from "../../../../../../store/transaction-certificates.store";

interface FacilityInfoFormProps {
  formRef: any;
  facilityData: FacilityInformation;
  setFacilityData: React.Dispatch<React.SetStateAction<FacilityInformation>>;
  mfExists?: boolean;
  mainSite?: FacilityState;
  setSubsequentFacilityFlag: React.Dispatch<React.SetStateAction<boolean>>;
  subsequentFacilityFlag: boolean;
  setScSubsequentFacilityButtonFlag: React.Dispatch<
    React.SetStateAction<boolean>
  >;

  processCodes: string[];
  // setIsFarmSite: React.Dispatch<React.SetStateAction<boolean>>;
  // scNoOfFarmsFlag: boolean;
  // setScNoOfFarmsFlag: React.Dispatch<React.SetStateAction<boolean>>;
  scSubsequentFacilityButtonFlag: boolean;
  facilityInfoData: FacilityProcessDetails[];
}

const FacilityInfoForm: React.FC<FacilityInfoFormProps> = ({
  formRef,
  facilityData,
  setFacilityData,
  mainSite,
  mfExists,
  setSubsequentFacilityFlag,
  subsequentFacilityFlag,
  setScSubsequentFacilityButtonFlag,
  processCodes,
  // setIsFarmSite,
  // scNoOfFarmsFlag,
  // setScNoOfFarmsFlag,
  scSubsequentFacilityButtonFlag,
  facilityInfoData,
}) => {
  const farmCodes = new Set(["PR0011", "PR0036", "PR0037", "PR0038"]);
  const supplyChainCodes = new Set(["PR0002", "PR0014", "PR0026"]);
  const exemptComboCodes = new Set(["PR0000", "PR0030", "PR0048"]);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { SC_ID } = useParams();
  const { executeGet } = useApi();
  const [cbLicensingCodes, setCBLicensingCodes] = useState([]);
  const [showWarning, setShowWarning] = useState(false);
  const { setCountries, setStates, setCBLicensingsCodes } =
    useTransactionCertificateStore();
  // const [countries, setCountries] = useState([]);
  // const [state, setState] = useState([]);

  const [visible, setVisible] = useState({
    iId: true,
    name: true,
    iIdLabel:
      facilityData?.facilityTeId && facilityData?.facilityTeId !== ""
        ? false
        : true,
  });
  const [isProdCapacityRequired, setIsProdCapRequired] =
    useState<boolean>(false);
  const [isFarmNumRequired, setIsFarmNumRequired] = useState<boolean>(false);
  const [countryOptions, setCountryOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);
  const [isLoadingStates, setIsLoadingStates] = useState(false);
  const [facilityTypeOptions, setFacilityTypeOptions] = useState([]);
  const [facilityCbOptions, setFacilityCbOptions] = useState([]);
  const [facilityStandardOptions, setFacilityStandardOptions] = useState([]);
  const [disable, setDisable] = useState({
    country: true,
    state: true,
    town: true,
    postcode: true,
    address1: true,
  });
  const [scValidFromDate, setScValidFromDate] = useState();
  const { notify } = useNotification();

  const getCountry = async () => {
    try {
      const result = await dtrackItServiceV4.getCountry();
      const countries = result.data.map((t: any) => ({
        value: t.code_1,
        label: `${t.description_1} (${t.code_1})`,
      }));
      setCountryOptions(countries);
      setCountries(countries);
    } catch (err) {
      notify("Failed to fetch countries", "error");
    }
  };
  const updateReqFields = (codes: string[]) => {
    const codeSet = new Set(codes);

    // Helper: check if all codes are in a given set
    const isSubsetOf = (targetSet: Set<string>) =>
      [...codeSet].every((code) => targetSet.has(code));

    // Case 1: Only farm codes → optional
    if (isSubsetOf(farmCodes)) return false;

    // Case 2: Only supply chain codes → optional
    if (isSubsetOf(supplyChainCodes)) return false;

    // Case 3: Only exempt combo codes → optional
    if (isSubsetOf(exemptComboCodes)) return false;

    // Case 4: Farm codes + any other code (except exempt ones) → mandatory
    const hasFarmCode = [...codeSet].some((code) => farmCodes.has(code));
    const hasNonExemptOtherCode = [...codeSet].some(
      (code) => !farmCodes.has(code) && !exemptComboCodes.has(code)
    );

    if (hasFarmCode && hasNonExemptOtherCode) return true;

    // Default: mandatory
    return false;
  };
  function computeFarmNumRequired(codes: string[]): boolean {
    const farmCodes = new Set(["PR0011", "PR0036", "PR0037", "PR0038"]);
    const supplyChainCodes = new Set(["PR0002", "PR0014", "PR0026"]);

    const codeSet = new Set(codes);
    const hasFarmCode = codes.some((code) => farmCodes.has(code));

    if (!hasFarmCode) return false;

    const nonFarmCodes = codes.filter((code) => !farmCodes.has(code));

    // Case 1: Only farm codes
    if (nonFarmCodes.length === 0) return true;

    // Case 2: Farm + supply chain codes only
    const allNonFarmAreSupplyChain = nonFarmCodes.every((code) =>
      supplyChainCodes.has(code)
    );
    if (allNonFarmAreSupplyChain) return true;

    // Case 3: Farm + other codes (excluding supply chain)
    const hasOtherNonSupplyChain = nonFarmCodes.some(
      (code) => !supplyChainCodes.has(code)
    );
    if (hasOtherNonSupplyChain) return true;

    return false;
  }
  const getState = async (countryCode: string) => {
    try {
      setIsLoadingStates(true);
      const result = await dtrackItServiceV4.getStateBasedonCountry(
        countryCode
      );
      const states = result.data.map((t: any) => ({
        value: t.code_1,
        label: `${t.description_1} (${t.code_1})`,
      }));
      setStateOptions(states);
      setStates(states);
    } catch (err) {
      setStateOptions([]);
    } finally {
      setIsLoadingStates(false);
    }
  };

  // Commented out hardcoded options - now using API calls
  // const facilityStandardCodes: OptionType[] = [
  //   { label: "Organic Content Standard (OCS)", value: "OCS" }, // Represents "Valid"
  //   { label: "Global Recycled Standard (GRS)", value: "GRS" }, // Represents "Expired"
  //   { label: "Recycled Claim Standard (RCS)", value: "RCS" }, // Represents "Suspended"
  //   { label: "Responsible Down Standard (RDS)", value: "RDS" }, // Represents "Withdrawn"
  //   { label: "Responsible Wool Standard (RWS)", value: "RWS" }, // Represents "Withdrawn"
  //   { label: "Responsible Mohair Standard (RMS)", value: "RMS" }, // Represents "Withdrawn"
  //   { label: "Responsible Alpaca Standard (RAS)", value: "RAS" }, // Represents "Withdrawn"
  //   { label: "Content Claim Standard (CCS)", value: "CCS" }, // Represents "Withdrawn"
  //   // { label: "SFA ", value: "SFA" }, // Represents "Withdrawn"
  //   // { label: "Global Organic Textile Standard (GOTS)", value: "GOTS" }, // Represents "Withdrawn"
  // ];
  const fetchTEDetails = async () => {
    const response: any = await executeGet(API_ROUTES.GET_CO_DETAILS_V4, {
      scId: SC_ID,
    });
    const mappedDetails = {
      account_name: response.data.certifiedOrganizationName,
      TE_ID: response.data.certifiedOrganizationTeId,
      street: response.data.certifiedOrganizationStreetAddress,
      city: response.data.certifiedOrganizationTown,
      postal_code: response.data.certifiedOrganizationPostcode,
      country: response.data.certifiedOrganizationCountryOrArea,
      state: response.data.certifiedOrganizationStateOrProvince,
    };
    // Move this check here to ensure it happens after data is loaded
    if (response?.certifiedOrganizationTeId) {
      setVisible((prev) => ({
        ...prev,
        iIdLabel: false,
      }));
    }
    return mappedDetails;
  };

  const fetchSCStandardDetails = async () => {
    const result = await executeGet(API_ROUTES.GET_SC_DETAILS_V4, {
      scId: SC_ID,
    });
    if (result?.data?.scStandardDetails?.length > 0) {
      const selectedStandards = result?.data.scStandardDetails.map(
        (detail: any) => detail.scStandard
      );
      setScValidFromDate(result?.data?.scValidFromDate);
      formRef?.current?.setFieldValue(
        "facilityAddedDate",
        result?.data?.scValidFromDate
      );
      formRef?.current?.setFieldValue("facilityStandard", selectedStandards);
      const scNoOfFarms = result?.data.scStandardDetails.filter(
        (detail: any) => detail.scNumberOfFarms > 0
      );
      // setScNoOfFarmsFlag(scNoOfFarms.length > 0);
      checkInitialValidations(scNoOfFarms.length > 0);
    }
    return result;
  };

  const fetchTEDetailsForMF = async () => {
    const details = await fetchTEDetails();
    handleSellerTEIdValueChange(details);
  };

  useEffect(() => {
    const getCBLicensingCodes = async () => {
      const result: any = await dtrackItServiceV4.getCBLicensingCodes();
      // Utills.cl(`result getCBLicensingCodes ${JSON.stringify(result)}`)
      const cbLicensing = result.data.map((t: any) => ({
        value: t.code_1,
        label: `${t.description_1}  `,
      }));
      // Utills.cl(`cbLicensing ${JSON.stringify(cbLicensing)}`)
      setCBLicensingCodes(cbLicensing);
      setCBLicensingsCodes(cbLicensing);
    };

    const getFacilityType = async () => {
      try {
        const result: any = await dtrackItServiceV4.getFacilityType();
        const facilityTypes = result.data.map((t: any) => ({
          value: t.code_1,
          label: `${t.description_1} (${t.code_1})`,
        }));
        setFacilityTypeOptions(facilityTypes);
      } catch (err) {
        notify("Failed to fetch facility types", "error");
      }
    };

    const getFacilityCbOptions = async () => {
      try {
        const result: any =
          await dtrackItServiceV4.getFacilityCbOfIndependentlyCertifiedSubcontractor();
        const facilityCbs = result.data.map((t: any) => ({
          value: t.code_1,
          label: `${t.description_1} (${t.code_1})`,
        }));
        setFacilityCbOptions(facilityCbs);
      } catch (err) {
        notify("Failed to fetch facility CB options", "error");
      }
    };

    const getFacilityStandards = async () => {
      try {
        const result: any = await dtrackItServiceV4.getScStandardValues();
        const facilityStandards = result.data.map((t: any) => ({
          value: t.code_1,
          label: `${t.description_1} (${t.code_1})`,
        }));
        setFacilityStandardOptions(facilityStandards);
      } catch (err) {
        notify("Failed to fetch facility standards", "error");
      }
    };

    getCBLicensingCodes();
    getFacilityType();
    getFacilityCbOptions();
    getFacilityStandards();

    if (!mfExists && facilityData?.facilityType === "MF") {
      fetchTEDetailsForMF();
    }
  }, []);

  useEffect(() => {
    if (facilityData?.facilityType === "MF") {
      setShowWarning(true);
    }
  }, [facilityData]);
  useEffect(() => {
    setIsProdCapRequired(updateReqFields(processCodes));
    setIsFarmNumRequired(computeFarmNumRequired(processCodes));
  }, [processCodes]);
  const fetchTEDetallsFromAPI = async (
    value: string,
    offset: number,
    type: string,
    name?: string
  ): Promise<any[]> => {
    try {
      const queryParams: Record<string, any> = {
        query_param: type == "query" ? value : "",
        offset: offset,
        name: type == "name" ? value : "",
      };
      const response = await buyerSellerDetailsService.getTEDetails(
        queryParams
      );
      const data = response.data;
      Utills.cl(
        `fetchTEDetallsFromAPI details, query ${JSON.stringify(
          queryParams
        )} response data ${JSON.stringify(data)}`
      );

      return data;
    } catch (error) {
      console.error("Error fetching TE details:", error);
      throw error;
    }
  };

  const handleSellerTEIdValueChange = (value: any) => {
    const fields = [
      "address1",
      "town",
      "postcode",
      "stateProvince",
      "countryArea",
      "name",
      "iId",
    ];
    if (value == null) {
      fields.forEach((field) => {
        formRef.current.setFieldValue(field, "");
      });
      setDisable((prev) => ({
        ...prev,
        country: true,
        state: true,
      }));
      setVisible((prev) => ({
        ...prev,
        // name: true,
        iIdLabel: true,
      }));
    } else {
      formRef.current.setFieldValue("facilityName", value.account_name || "");
      formRef.current.setFieldValue("facilityTeId", value.TE_ID);
      // formRef.current.setFieldValue("address1", value.street);

      //handle address1
      if (value.street == null) {
        setDisable((prev) => ({
          ...prev,
          address1: false,
        }));
        formRef.current.setFieldValue("facilityAddress1", "");
      } else {
        setDisable((prev) => ({
          ...prev,
          address1: true,
        }));
        formRef.current.setFieldValue("facilityAddress1", value.street);
      }

      setScSubsequentFacilityButtonFlag(true);
      // setSubsequentFacilityFlag(true);
      // Handle town
      if (value.city != null) {
        setDisable((prev) => ({
          ...prev,
          town: true,
        }));
        formRef.current.setFieldValue("facilityTown", value.city);
      } else {
        setDisable((prev) => ({
          ...prev,
          town: false,
        }));
        formRef.current.setFieldValue("facilityTown", "");
      }
      // Handle postcode
      if (value.postal_code != null) {
        setDisable((prev) => ({
          ...prev,
          postcode: true,
        }));
        formRef.current.setFieldValue("facilityPostcode", value.postal_code);
      } else {
        setDisable((prev) => ({
          ...prev,
          postcode: false,
        }));
        formRef.current.setFieldValue("facilityPostcode", "");
      }

      // Handle country
      if (value.country) {
        let countryCode = JSON.stringify(
          `[${[value.country].map((item) => `'${item}'`)}]`
        ).replace(/^"|"$/g, "");
        getState(countryCode);
        formRef.current.setFieldValue("facilityCountryOrArea", value.country);
        setDisable((prev) => ({
          ...prev,
          country: true,
          state: false, // Enable state dropdown if only country exists
        }));
      }

      // Handle state separately
      if (value.state) {
        formRef.current.setFieldValue("facilityStateOrProvince", value.state);
        setDisable((prev) => ({
          ...prev,
          state: true,
        }));
      } else {
        setDisable((prev) => ({
          ...prev,
          state: false, // Enable state dropdown if state is not provided
        }));
      }

      setVisible((prev) => ({
        ...prev,
        // name: false,
        iIdLabel: value?.TE_ID && value?.TE_ID !== "" ? false : true,
      }));
    }
  };
  useEffect(() => {
    if (facilityData?.facilityCountryOrArea) {
      let countryCode = JSON.stringify(
        `[${[facilityData.facilityCountryOrArea].map((item) => `'${item}'`)}]`
      ).replace(/^"|"$/g, "");
      getState(countryCode);
    }
  }, [facilityData?.facilityCountryOrArea]);

  useEffect(() => {
    if (SC_ID) {
      fetchSCStandardDetails();
    }

    getCountry();
  }, []);

  const checkInitialValidations = (scFarmsFlag: boolean) => {
    const farmCategories = [
      "PR0036",
      "PR0011",
      "PR0037",
      "PR0038",
      "PR0002",
      "PR0014",
      "PR0026",
    ];
    const selectedProcesses = facilityInfoData.filter((process) =>
      farmCategories.includes(process.facilityProcessCategoryCode)
    );
    if (
      facilityData?.facilityType !== "MF" &&
      // scFarmsFlag &&
      selectedProcesses.length > 0
    ) {
      setSubsequentFacilityFlag(true);
      setVisible((prev) => ({
        ...prev,
        name: false,
      }));
      setDisable((prev) => ({
        ...prev,
        postcode: false,
        town: false,
        country: false,
        state: false,
        address1: false,
      }));
      setScSubsequentFacilityButtonFlag(true);
    } else {
      setSubsequentFacilityFlag(false);
    }
  };

  const handleSellerNameValueChange = (value: any) => {
    Utills.cl("I am in handleSellerNameValueChange");
    const fields = [
      "address1",
      "town",
      "postcode",
      "stateProvince",
      "countryArea",
      "name",
      "iId",
    ];
    if (value == null) {
      fields.forEach((field) => {
        formRef.current.setFieldValue(field, "");
      });

      setVisible((prev) => ({
        ...prev,
        iId: true,
      }));
    } else {
      formRef.current.setFieldValue("facilityName", value.account_name);
      formRef.current.setFieldValue("facilityTeId", value.TE_ID);
      // formRef.current.setFieldValue("address1", value.street);

      //handle address1
      if (value.street == null) {
        setDisable((prev) => ({
          ...prev,
          address1: false,
        }));
        formRef.current.setFieldValue("facilityAddress1", "");
      } else {
        setDisable((prev) => ({
          ...prev,
          address1: true,
        }));
        formRef.current.setFieldValue("facilityAddress1", value.street);
      }
      // Handle town
      if (value.city != null) {
        setDisable((prev) => ({
          ...prev,
          town: true,
        }));
        formRef.current.setFieldValue("facilityTown", value.city);
      } else {
        setDisable((prev) => ({
          ...prev,
          town: false,
        }));
        formRef.current.setFieldValue("facilityTown", "");
      }
      // Handle postcode
      if (value.postal_code != null) {
        setDisable((prev) => ({
          ...prev,
          postcode: true,
        }));
        formRef.current.setFieldValue("facilityPostcode", value.postal_code);
      } else {
        setDisable((prev) => ({
          ...prev,
          postcode: false,
        }));
        formRef.current.setFieldValue("facilityPostcode", "");
      }
      formRef.current.setFieldValue(
        "facilityCountryOrArea",
        value?.country === null ? "" : value?.country
      );
      setDisable((prev) => ({
        ...prev,
        country: value?.country != null ? true : false,
      }));
      formRef.current.setFieldValue(
        "facilityStateOrProvince",
        value.state == null ? "" : value.state
      );
      setVisible((prev) => ({
        ...prev,
        iId: false,
      }));
    }
  };

  const toggleDrawer = () => {
    if (drawerOpen) resetForm();
    setDrawerOpen((prev) => !prev);
  };

  const resetForm = () => {
    setFacilityData(facilityData);
  };

  const formConfig: FormConfigProps = {
    pageName: "sc-facilitydetails",
    initialValues: facilityData,
    validationSchema: Yup.object().shape({
      // facilityNo: Yup.string().required("Facility No. is required"),
      ...(mfExists == true
        ? {
            facilityType: Yup.string()
              .test(
                "is-mf",
                "Main Facility already exists. Choose a different facility type.",
                (value: string | undefined, context: Yup.TestContext) => {
                  const teId = context.parent.facilityTeId; // Access another field
                  return !(
                    value === "MF" &&
                    teId !== mainSite?.facilityInfo?.facilityTeId
                  );
                }
              )
              .required("Facility Type is required"),
          }
        : { facilityType: Yup.string().required("Facility Type is required") }),
      // facilityOARId: Yup.string().optional(),
      facilityLastAuditDate: Yup.date().when("facilityType", {
        is: "CS",
        then: (schema) => schema.optional(),
        otherwise: (schema) =>
          schema.required("Facility Last Audit Date is required"),
      }),
      facilityFarmNoAnimals: isFarmNumRequired
        ? Yup.string().required("Please enter Farm No. of animals")
        : Yup.string(),
      facilityTeId: Yup.string().when("facilityType", {
        is: (value: string) => subsequentFacilityFlag,
        then: (schema) => schema.optional(),
        otherwise: (schema) => schema.required("TE-ID is required"),
      }),
      brandNames: Yup.string(),
      facilityStandard: Yup.array()
        .of(Yup.string())
        .min(1, "At least one Facility Standard must be selected")
        .required("Facility Standard is required"),
      facilityName: Yup.string().required("Name is required"),
      facilityAddress1: Yup.string().required("Address 1 is required"),
      facilityPostcode: Yup.string().nullable(),
      facilityTown: Yup.string().nullable(),
      facilityCountryOrArea: Yup.string().required("Country/Area is required"),
      facilityStateOrProvince: Yup.string().required(
        "State/Province is required"
      ),
      facilityCbOfIndependentlyCertifiedSubcontractor:
        formRef?.cuurent?.values?.facilityType === "CS"
          ? Yup.string().required(
              "Please enter CB of Independently Certified Subcontractor"
            )
          : Yup.string(),
      facilityAddedDate: Yup.date()
        .test(
          "not-added-before-sc-created",
          "Facility Added Date cannot be before SC Valid From Date",
          function (value) {
            if (!value || !scValidFromDate) return true;
            return new Date(value) >= new Date(scValidFromDate+"T00:00:00Z");
          }
        )
        .required(),
      facilityRemovedDate: Yup.date().test(
        "facility-removed-sequence",
        "Facility Removed Date must be after or equal to Facility Added Date",
        function (value) {
          const firstCreated = this.parent.facilityAddedDate;
          if (!firstCreated || !value) return true;
          return new Date(firstCreated) <= new Date(value);
        }
      ),
    }),
    sections: [
      {
        title: "Facility Information",
        fields: [
          // {
          //   label: "Facility No.",
          //   name: "facilityNo",
          //   type: "text",
          //   gridSize: { xs: 12, md: 6, lg: 4 },
          //   required: true,
          //   props: { placeholder: "Enter Facility No." },
          // },
          {
            label: "Facility Type",
            name: "facilityType",
            type: "select",
            disabled: !mfExists && facilityData?.facilityType === "MF",
            gridSize: { xs: 12, md: 6, lg: 4 },
            required: true,
            props: {
              options: facilityTypeOptions,
              placeholder: "Select Facility Type",
            },
            events: {
              onChange: async (updatedValue: any) => {
                setShowWarning(updatedValue === "MF");
                setVisible((prev) => ({
                  ...prev,
                  iId: false,
                }));
                if (updatedValue === "MF") {
                  const details = await fetchTEDetails();
                  console.log("Mapped Details:", details);
                  handleSellerTEIdValueChange(details);
                } else {
                  setVisible((prev) => ({
                    ...prev,
                    iId: true,
                  }));
                  const mappedDetails = {
                    account_name: "",
                    TE_ID: "",
                    street: "",
                    city: "",
                    postal_code: "",
                    country: "",
                    state: "",
                  };
                  handleSellerTEIdValueChange(mappedDetails);
                }
                if (
                  updatedValue !== "MF"
                  // && scNoOfFarmsFlag
                ) {
                  setSubsequentFacilityFlag(true);
                  setVisible((prev) => ({
                    ...prev,
                    name: false,
                  }));
                  setDisable((prev) => ({
                    ...prev,
                    postcode: false,
                    town: false,
                    country: false,
                    state: false,
                    address1: false,
                  }));
                  formRef.current?.setFieldValue("facilityCountryOrArea", "");
                  formRef.current?.setFieldValue("facilityStateOrProvince", "");
                } else {
                  setSubsequentFacilityFlag(false);
                }
              },
            },
            ...(mfExists ? {} : { value: "MF" }),
          },
          {
            label: "Facility TE-ID",
            name: "facilityTeId",
            type: "search",
            gridSize: { xs: 12, md: 6, lg: 4 },
            required: true, //(values: any) => !subsequentFacilityFlag,
            value: facilityData.facilityTeId,
            visible: (value: any) => visible.iId,
            props: {
              placeholder: "Search TE-ID",
              variant: "outlined",
              restrictInputFormat: visible?.iIdLabel,
              param: "facilityTeId",
              onChange: handleSellerTEIdValueChange,
              displayKey: "TE_ID",
              onSearch: (query: string, offset: number) => {
                const response = fetchTEDetallsFromAPI(query, offset, "query");
                return response;
              },
              fullWidth: true,
            },
          },
          {
            label: "Facility TE-ID",
            name: "facilityTeId",
            type: "text",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: true, // (values: any) => values.facilityType !== "FA",
            // value: 'initialValues.sellerAddress1',
            disabled: true,
            visible: (value: any) => !visible.iId,
            props: {
              placeholder: "Enter TE-ID",
              fullWidth: true,
            },
          },
          {
            label: "Facility Name",
            name: "facilityName",
            type: "search",
            gridSize: { xs: 12, md: 6, lg: 4 },
            required: true,
            value: facilityData.facilityName,
            visible: (value: any) => visible.name,
            props: {
              placeholder: "Search Name",
              variant: "outlined",
              param: "name",
              onChange: handleSellerNameValueChange,
              displayKey: "account_name",
              onSearch: (query: string, offset: number) => {
                const response = fetchTEDetallsFromAPI(query, offset, "name");
                return response;
              },
              fullWidth: true,
            },
          },
          {
            label: "Facility Name",
            name: "facilityName",
            type: "text",
            gridSize: { xs: 12, md: 6, lg: 4 },
            required: true,
            disabled: visible.name,
            visible: (value: any) => !visible.name,
            props: {
              placeholder: "Enter Name",
              fullWidth: true,
            },
          },

          {
            label: "Facility Street Address",
            name: "facilityAddress1",
            type: "text",
            gridSize: { xs: 12, md: 6, lg: 4 },
            required: true,
            disabled: disable?.address1,
            props: { placeholder: "Enter Address 1" },
          },
          {
            label: "Facility Town",
            name: "facilityTown",
            type: "text",
            gridSize: { xs: 12, md: 6, lg: 4 },
            required: false,
            disabled: disable?.town,
            props: { placeholder: "Enter Town" },
          },
          {
            label: "Facility Postcode",
            name: "facilityPostcode",
            type: "text",
            gridSize: { xs: 12, md: 6, lg: 4 },
            required: false,
            disabled: disable?.postcode,
            props: { placeholder: "Enter Postcode" },
          },
          {
            label: "Facility Country/Area",
            name: "facilityCountryOrArea",
            type: "select",
            gridSize: { xs: 12, md: 6, lg: 4 },
            required: true,
            disabled: (values: any) => disable.country,
            events: {
              onChange: (newValue: any) => {
                let countryCode = JSON.stringify(
                  `[${[newValue].map((item) => `'${item}'`)}]`
                ).replace(/^"|"$/g, "");
                getState(countryCode);
              },
            },
            props: {
              enableSearch: true,
              options: countryOptions,
              placeholder: "Select Country/Area",
              fullWidth: true,
            },
          },
          {
            label: "Facility State/Province",
            name: "facilityStateOrProvince",
            type: "select",
            gridSize: { xs: 12, md: 6, lg: 4 },
            required: true,
            disabled: (values: any) => disable.state,
            props: {
              options: stateOptions,
              enableSearch: true,
              placeholder: "Select State/Province",
              fullWidth: true,
              loading: isLoadingStates,
            },
          },
          // {
          //   label: 'Facility OAR ID',
          //   name: 'facilityOARId',
          //   type: 'text',
          //   gridSize: { xs: 12, md: 6, lg: 4 },
          //   required: false,
          //   props: { placeholder: 'Enter OAR ID' },
          // },
          {
            label: "Facility Added Date",
            name: "facilityAddedDate",
            type: "date",
            gridSize: { xs: 12, md: 6, lg: 4 },
            required: true,
            props: { placeholder: "Select Added Date" },
          },
          {
            label: "Facility Removed Date",
            name: "facilityRemovedDate",
            type: "date",
            gridSize: { xs: 12, md: 6, lg: 4 },
            required: false,
            props: { placeholder: "Select Removed Date" },
          },
          {
            label: "Facility Last Audit Date",
            name: "facilityLastAuditDate",
            type: "date",
            gridSize: { xs: 12, md: 6, lg: 4 },
            required: (values: any) => values.facilityType !== "CS",
            props: { placeholder: "Select Last Audit Date" },
          },
          {
            label: "Facility Standard",
            name: "facilityStandard",
            type: "select",
            gridSize: { xs: 12, md: 6, lg: 4 },
            disabled: (values: any) => values.facilityType === "MF",
            required: true,
            props: {
              multiple: true,
              options: facilityStandardOptions,
              placeholder: "Select Facility Standard",
            },
          },
          {
            label: "Facility OS ID",
            name: "facilityOsId",
            type: "text",
            gridSize: { xs: 12, md: 6, lg: 4 },
            required: false,
            props: { placeholder: "Enter OS ID" },
          },
          {
            label: "Facility Additional Scopes",
            name: "facilityAdditionalScopes",
            type: "text",
            gridSize: { xs: 12, md: 6, lg: 4 },
            required: false,
            props: { placeholder: "Enter Additional Scopes" },
          },
          // {
          //   label: "Subcontractor License No.",
          //   name: "subcontractorLicenseNo",
          //   type: "text",
          //   gridSize: { xs: 12, md: 6, lg: 4 },
          //   disabled: (values: any) => values?.facilityType !== "CS",
          //   required: (values: any) => {
          //     return values.facilityType == "CS" ? true : false;
          //   },
          //   visible: (values: any) => values.facilityType === "CS",
          //   props: { placeholder: "Enter Subcontractor License No." },
          // },
          {
            label: "Facility Production Capacity",
            // visible:(values)=>scNoOfFarmsFlag && (values?.facilityType === "MF" || values?.facilityType === "FA"),
            visible: () => true,
            name: "facilityProductionCapacity",
            type: "text",
            gridSize: { xs: 12, md: 6, lg: 6 },
            required: isProdCapacityRequired,
            props: { placeholder: "Enter Farm Capacity" },
          },
          {
            label: "Facility Farm No. Of Animals",
            visible: () => true,
            // visible:(values)=>scNoOfFarmsFlag && (values?.facilityType === "MF" || values?.facilityType === "FA"),
            name: "facilityFarmNoAnimals",
            type: "text",
            gridSize: { xs: 12, md: 6, lg: 6 },
            required: isFarmNumRequired,
            helperText: (values: any) => {
              const selectedStandards = values?.facilityStandard || [];
              const rafStandards = selectedStandards.filter(
                (standard: string) => ["RMS", "RAS", "RWS"].includes(standard)
              );
              const hasRDS = selectedStandards.includes("RDS");

              if (rafStandards.length > 0 || hasRDS) {
                let message = "Submit ";

                if (rafStandards.length > 0) {
                  message += `number of animals for ${rafStandards.join(", ")}`;
                }

                if (rafStandards.length > 0 && hasRDS) {
                  message += " and ";
                }

                if (hasRDS) {
                  message += "number of birds for RDS";
                }

                return message;
              }
              return "";
            },
            props: { placeholder: "Enter Number of Animals" },
          },

          {
            label: "CB of Independently Certified Subcontractor",
            name: "facilityCbOfIndependentlyCertifiedSubcontractor",
            type: "select",
            gridSize: { xs: 12, md: 6, lg: 6 },
            required: (values: any) => values?.facilityType === "CS",
            visible: (values: any) => values.facilityType === "CS",
            props: {
              options: facilityCbOptions,
              placeholder: "Select Certification Body",
            },
          },
          // {
          //   label: "Expiry Date of Independently Certified Subcontractor",
          //   name: "expiryDate",
          //   type: "date",
          //   gridSize: { xs: 12, md: 6, lg: 6 },
          //   disabled: false,
          //   required: false,
          //   visible: (values: any) => values.facilityType === "CS",
          //   props: { placeholder: "Select Expiry Date", disableFuture: false },
          // },
        ],
      },
    ],
    handleSubmit: (values) => {
      setFacilityData(values); // Assumes `setFacilityData` is defined elsewhere
      toggleDrawer(); // Assumes `toggleDrawer` is defined elsewhere
    },
  };

  return (
    <>
      {showWarning && (
        <Box
          sx={{
            p: 2,
            mb: 2,
            bgcolor: "#FFF3E0",
            borderRadius: 1,
            border: "1px solid #FFB74D",
          }}
        >
          <Typography color="warning.dark">
            Note: Any changes to the Certified Organization (CO) details should
            be made in the "Certified Organization Details" tab.
          </Typography>
        </Box>
      )}
      <FormBuilder
        formConfig={formConfig}
        onSubmit={formConfig.handleSubmit}
        formRef={formRef}
      />
    </>
  );
};

export default FacilityInfoForm;
